// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-directors-page-jsx": () => import("/opt/build/repo/src/templates/directorsPage.jsx" /* webpackChunkName: "component---src-templates-directors-page-jsx" */),
  "component---src-pages-404-jsx": () => import("/opt/build/repo/src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-authors-page-jsx": () => import("/opt/build/repo/src/pages/AuthorsPage.jsx" /* webpackChunkName: "component---src-pages-authors-page-jsx" */),
  "component---src-pages-index-jsx": () => import("/opt/build/repo/src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

